import { colors, spacing } from '@lamimed/pantheon';

import * as S from './styles';

export interface ContentFadeProps {
  haveScrollContent?: boolean;
  alignment?: 'end' | 'center';
  hasMoreContent?: boolean;
  paddingBottom?: keyof typeof spacing;
  desktopPosition?: 'absolute' | 'fixed' | 'static';
  color?: keyof typeof colors;
}

export const ContentFade: React.FC<
  React.PropsWithChildren<ContentFadeProps>
> = ({
  haveScrollContent,
  alignment = 'end',
  hasMoreContent = false,
  paddingBottom,
  desktopPosition,
  color,
  children,
}) => {
  return (
    <S.ContentFadeWrapper
      haveScrollContent={haveScrollContent}
      alignment={alignment}
      hasMoreContent={hasMoreContent}
      desktopPosition={desktopPosition}
    >
      <S.Fade fadeColor={color} />

      <S.ContentContainer
        hasChildren={!!children}
        paddingBottom={paddingBottom}
        fadeColor={color}
      >
        {children}
      </S.ContentContainer>
    </S.ContentFadeWrapper>
  );
};
